// extracted by mini-css-extract-plugin
module.exports = {"section":"PaginaInicial_section__27Lcf","welcome":"PaginaInicial_welcome__A6sJ1","headerText":"PaginaInicial_headerText__ZutCe","mainText":"PaginaInicial_mainText__mNdVF"};